import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { LoginService } from '@user/data-access';
import { Observable } from 'rxjs';

/**
 * Интерсептор используется для передачи параметра с типом логаута.
 * В коробке не реализована возможность передавать дополнительные параметры
 * в роут логаута. Чтобы не переопределять коробочные классы, параметр
 * передается через интерсептор.
 */
@Injectable({
  providedIn: 'root',
})
export class LogoutInterceptor implements HttpInterceptor {
  constructor(
    private loginService: LoginService,
    private occEndpointsService: OccEndpointsService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      req.url.includes(
        this.occEndpointsService.getBaseUrl({ prefix: false, baseSite: false }) + '/authorizationserver/oauth2/logout',
      )
    ) {
      return next.handle(
        req.clone({
          body: req.body.set('logout_type', this.loginService.getLogoutType()),
        }),
      );
    }

    return next.handle(req);
  }
}
